import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { GenericError } from '@cian/peperrors/shared';
export var ValidationError = /*#__PURE__*/function (_GenericError) {
  /* istanbul ignore next */
  function ValidationError(_ref) {
    var _this;
    var domain = _ref.domain,
      message = _ref.message,
      errors = _ref.errors;
    _classCallCheck(this, ValidationError);
    _this = _callSuper(this, ValidationError, [{
      domain: domain,
      message: message,
      type: 'ValidationError'
    }]);
    _defineProperty(_this, "errors", void 0);
    Object.setPrototypeOf(_this, ValidationError.prototype);
    _this.errors = errors;
    return _this;
  }
  _inherits(ValidationError, _GenericError);
  return _createClass(ValidationError);
}(GenericError);